import { render, staticRenderFns } from "./AttachmentRichText.vue?vue&type=template&id=432d4467&scoped=true&"
import script from "./AttachmentRichText.vue?vue&type=script&lang=js&"
export * from "./AttachmentRichText.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentRichText.vue?vue&type=style&index=0&id=432d4467&prod&lang=scss&scoped=true&"
import style1 from "./AttachmentRichText.vue?vue&type=style&index=1&id=432d4467&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432d4467",
  null
  
)

export default component.exports